module.exports = __webpack_public_path__ + "assets/img/Quorn-Pillar-Page-Resource-w720.63be51e5.jpg";